<div class="existing-inn-name-container" [formGroup]="currentForm">
  <div id="existing-inn-name-text" class="existing-inn-name-text" [ngClass]="{ 'existing-inn-name-text__full' : !isMobileDeviceSize }">
    Does the name you're requesting already have an INN?
  </div>
  <div class="radio-input-row">
    <input type="radio" aria-label="Yes" [id]="'innExists'" [value]="'Yes'" name="existingInnNameSelected" formControlName="innSubmission" (change)="updateInnSubmission('Yes')" [checked]="compareFn('Yes')">
    <label [for]="'innExists'">Yes</label>
    <input type="radio" aria-label="No" [id]="'innDoesntExist'" [value]="'No'" name="existingInnNameSelected" formControlName="innSubmission" (change)="updateInnSubmission('No')" [checked]="compareFn('No')">
    <label [for]="'innDoesntExist'">No</label>
  </div>
   <div class="input-error" *ngIf="hasFieldValidationError('innSubmission', 'required')">
    This is a required field.
  </div>
</div>